/**
 * Formats minor units (pence/cents, as Liquid and /cart.js give them) in the cart's currency.
 * Surcharges drop ".00" the way Figma writes them ("(+£5)").
 * @param {number} amount  minor units
 * @param {{ currency?: string, locale?: string, trimWhole?: boolean }} [options]
 * @returns {string}
 */
export function formatMoney(amount, { currency = 'GBP', locale, trimWhole = false } = {}) {
  const value = (Number(amount) || 0) / 100;
  const whole = Number.isInteger(value);
  return new Intl.NumberFormat(locale || document.documentElement.lang || 'en-GB', {
    style: 'currency',
    currency,
    minimumFractionDigits: trimWhole && whole ? 0 : 2,
    maximumFractionDigits: 2
  }).format(value);
}
